export default __webpack_public_path__ + "static/media/pin.2dae0c85.svg";